<template>
  <GModal class="modal--tell-friends custom-modal">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" @click.prevent="closeModal" />
      </button>
      <span class="modal-heading">{{ productData.is_modal_review ? 'Share This Product' : 'Share To Friends' }}</span>
    </div>

    <div slot="body">
      <!-- <div v-if="productData" class="product-preview">
        <figure>
          <img :src="productData.image_cover" />
        </figure>
        <div class="product-content">
          <div class="brand">{{ (productData.manufacture && productData.manufacture.name) || '-' }}</div>
          <div class="name">{{ 'name' in productData ? productData.name : '-' }}</div>
          <div class="average-rating--uniform">
            <div class="rating--uniform timeline-review">
              <div :class="[`rate-star--uniform rate-star--uniform-${averageRating * 10}`]">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <span v-if="productData.from_page === 'pdp'" class="count">{{
                averageRating ? averageRating : '0.0'
              }}</span>
              <span v-else class="count">{{
                productData.average_rating ? parseFloat(productData.average_rating).toFixed(1) : '0.0'
              }}</span>
              <div class="rating">({{ productData.total_reviews }})</div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="input-group">
                <input type="text" class="form-control" v-model="url" name="url" readonly>
                <button @click.prevent="copyUrl(url, 'link')" class="form-button btn" type="button" :disabled="!url" ref="link">COPY LINK</button>
            </div>	 -->
      <p class="tell-friend-text">Bagikan tautan tentang produk ini ketemanmu sekarang!</p>
      <div class="input-group-v2">
        <input :value="url" type="text" class="form-control" name="url" readonly />
        <button
          ref="link"
          class="form-button btn copy-link-btn"
          type="button"
          :disabled="!url"
          @click.prevent="copyUrl(url, 'link')"
        >
          Copy link
        </button>
      </div>
    </div>
    <div slot="footer">
      <div class="button--sosmed">
        <a
          :href="share('facebook')"
          title="Share to Facebook"
          target="_blank"
          rel="noopener noreferrer"
          class="icon icon--fb"
          ><SvgImg name="btn-fb" width="14" height="14"
        /></a>
        <a
          :href="share('twitter')"
          title="Share to Twitter"
          target="_blank"
          rel="noopener noreferrer"
          class="icon icon--twitter"
          ><SvgImg name="btn-twitter" width="14" height="14"
        /></a>
        <a
          :href="share('whatsapp')"
          title="Share to Whatsapp"
          target="_blank"
          rel="noopener noreferrer"
          class="icon icon--whatsapp"
          ><SvgImg name="whatsapp" width="24" height="24"
        /></a>
        <a
          :href="share('email')"
          title="Share to Whatsapp"
          target="_blank"
          rel="noopener noreferrer"
          class="icon icon--mail"
          ><SvgImg name="email" width="24" height="24"
        /></a>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'ModalTellFriends',
  computed: {
    url() {
      if (this.$store.state.modal.productData) {
        const productData = this.$store.state.modal.productData;
        if (
          this.$store.state.modal.productData &&
          Object.keys(this.$store.state.modal.productData).length &&
          this.$store.state.modal.productData.default_category !== undefined
        ) {
          return `${this.$store.state.REVIEW_WEB_URL}/product/${this.$options.filters.slug(
            productData.default_category.name
          )}/${productData.id}-${this.$options.filters.slug(productData.name)}`;
        } else if (this.$store.state.modal.productData && Object.keys(this.$store.state.modal.productData).length) {
          return `${this.$store.state.REVIEW_WEB_URL}/product/default/${productData.id}-${this.$options.filters.slug(
            productData.name
          )}`;
        }
      }

      return encodeURI(`${this.$store.state.REVIEW_WEB_URL}${window.location.pathname}`);
    },
    isOpen() {
      return this.$store.state.modal.isModalShow.ModalTellFriends;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    page_info_title() {
      if ('page_info_title' in this.$store.state.header) {
        return this.$store.state.header.page_info_title;
      }
    },
    reviewSite() {
      return this.$store.state.REVIEW_WEB_URL;
    },
    windowURL() {
      return encodeURI(window.location.href);
    },
    productData() {
      let result = {};
      if (this.$store.state.modal.productData && Object.keys(this.$store.state.modal.productData).length) {
        result = this.$store.state.modal.productData;
      }
      return result;
    },
    averageRating() {
      let result = 0;
      try {
        if (this.$SO.size(this.productData) && this.productData.from_page === 'pdp') {
          if (this.$SO.size(this.productData.review_stats) && this.productData.review_stats.average_rating) {
            result = this.$options.filters.productrating(this.productData.review_stats.average_rating);
          }
        } else {
          result = this.productData.average_rating;
        }
      } catch (error) {}
      return result;
    },
    reviewData() {
      return this.$store.state.reviewData;
    },
    isHaveReviewData() {
      return Boolean(Object.keys(this.reviewData).length);
    },
  },
  mounted() {
    document.documentElement.classList.add('noscroll');
  },
  beforeDestroy() {
    document.documentElement.classList.remove('noscroll');
  },
  methods: {
    share(platform) {
      const domain = this.$store.state.REVIEW_WEB_URL;
      const product = this.$store.state.header.page_info_title;
      const brand = this.$store.state.header.page_info_brand;
      if (platform == 'facebook') {
        if (this.isHaveReviewData) {
          if (this.reviewData.user.is_expert_reviewer) {
            return `https://www.facebook.com/sharer.php?u=${domain}/review/${this.reviewData._id}`;
          }
        }
        if (!brand) {
          return `https://www.facebook.com/sharer.php?u=${this.url}`;
        } else {
          return `https://www.facebook.com/sharer.php?u=${domain + this.$route.path}`;
        }
      }
      if (platform == 'twitter') {
        if (!brand) {
          // return `https://twitter.com/intent/tweet?text=Review ${product} - ${domain + this.$route.path}`;
          return `https://twitter.com/intent/tweet?text=Review ${product} - ${this.url}`;
        } else {
          return `https://twitter.com/intent/tweet?text=Review ${brand} - ${product} - ${domain + this.$route.path}`;
        }
      }
      if (platform == 'whatsapp') {
        if (this.isHaveReviewData) {
          if (this.reviewData.user.is_expert_reviewer) {
            return `https://wa.me/?text=${domain}/review/${this.reviewData._id}`;
          }
        }
        if (!brand) {
          // return `https://wa.me/?text=Review ${product} - ${domain + this.$route.path}`;
          return `https://wa.me/?text=Review ${product} - ${this.url}`;
        } else {
          return `https://wa.me/?text=Review ${brand} - ${product} - ${domain + this.$route.path}`;
        }
      }
      if (platform == 'email') {
        if (!brand) {
          // return `mailto:?subject=Sociolla%20Review&&body=${product} - ${domain + this.$route.path}`;
          return `mailto:?subject=Sociolla%20Review&&body=${product} - ${this.url}`;
        } else {
          return `mailto:?subject=Sociolla%20Review&&body=${brand} ${product} - ${domain + this.$route.path}`;
        }
      }
    },
    copyUrl(text, refs) {
      this.$copyText(text).then(
        (e) => {
          this.$refs[refs].innerHTML = 'Copied!';
          setTimeout(() => {
            this.$refs[refs].innerHTML = 'Copy link';
          }, 1000);
        },
        function (e) {
          console.log('Can not copy the link!');
        }
      );
    },
    closeModal() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'tellFriends' });
      this.$store.commit('setReviewData', {});
    },
  },
};
</script>
